import moment from "moment"

export const insertTravelDates = (targetDates, currentDates) => {
  // Initialize the return array
  const results = [...currentDates]
  // Loop over target dates
  for (
    let targetDateIndex = 0;
    targetDateIndex < targetDates.length;
    targetDateIndex += 1
  ) {
    const targetDate = targetDates[targetDateIndex]
    // Initialize a flag to track if the target day has been added
    let targetDateIsAdded = false
    // Map over the results array to insert the target dates at the correct indices
    results.forEach((result, resultIndex) => {
      // If the target date has been added already, return
      if (targetDateIsAdded) return
      // If the target date is not the latest date in the jurisdiction
      if (moment(targetDate.date).diff(result.date, "days") < 1) {
        // Determine that the target date has been added
        targetDateIsAdded = true
        // Insert the target date at this index and return
        return results.splice(resultIndex, 0, targetDate)
      }
    })
    // If the target date is the latest date in the jurisdiction, push it
    if (!targetDateIsAdded) results.push(targetDate)
  }

  return results
}
